module.exports = __webpack_public_path__ + "img/placeholder-notification.9c464b1a.svg";